module.exports = __webpack_public_path__ + "img/maijia-bg.d7aab161.jpg";